export default function roleFilter(role) {
  if (!role) return;
  const role_list = [
    {name: 'владелец', id: 1},
    {name: 'администратор', id: 2},
    {name: 'игрок', id: 3},
  ];
  return role_list.find(el => el.id === role).name;
}